import {Input} from '@logistics-frontend/blocks/lpc/input'
import {useI18n} from '@logistics-frontend/core/i18n'
import {useAddress, useAddressFloor} from '@yandex-taxi/react-integration-api'
import React, {useEffect} from 'react'

import {useAddressGoalCallback} from '../../../../../shared/metrika'
import {isSuitableExtraDataMethod, Props} from './utils'

const Floor: React.FC<Props> = ({index, length}) => {
  const t = useI18n()
  const goalCallback = useAddressGoalCallback(index, length)
  const [{value: floor = ''}, {setValue: setFloor}] = useAddressFloor(index)
  const [{value}] = useAddress(index)

  // @ts-expect-error тпизация int-api
  const floorNumber = value?.floor_number
  // @ts-expect-error тпизация int-api
  const method = value?.method

  useEffect(() => {
    isSuitableExtraDataMethod(method) ? setFloor(floorNumber) : setFloor('')
  }, [floorNumber, setFloor, method])

  return (
    <Input
      onBlur={() => goalCallback('Floor')}
      onChange={event => setFloor(event.target.value)}
      placeholder={t('order.form.floor_placeholder', 'Этаж')}
      value={floor}
      fullWidth
    />
  )
}

export default Floor
